import styled, { css } from 'styled-components';

import Grid from '../../_shared/components/Grid';
import Box from '../../_shared/components/Box';

const tradeGridVariants = {
  grid: css`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  `,
  list: css`
    width: 100%;
    max-width: 882px;
  `,
  search: css`
    width: 100%;
  `
};

const tradeIsInSaleEventVariants = {
  true: css`
    border-left: 6px solid ${({ theme }) => theme.COLORS.TERTIARY};
    border-right: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    background: ${({ theme }) => theme.COLORS.BASE};
  `
};

export const StyledTradeGrid = styled(Grid).attrs(props => ({
  variant: props.variant
}))`
  ${props => tradeGridVariants[props.variant]}
`;

export const StyledTradeGridWrapper = styled(Box.Column)`
  ${props => tradeIsInSaleEventVariants[props.isInSaleEvent]}
`;
